<template>
    <v-dialog style="overflow-y: hidden;" width="70%" v-model="dialogControl">
        <v-card class="dialog-card">
            <v-flex class="inner-card-flex">
                <v-form ref="groupDealForm" lazy-validation>
                    <v-row style="position: relative;">
                        <v-btn @click="dialogControl = false" class="top-right-close-btn" icon>
                            <v-icon>fas fa-times</v-icon>
                        </v-btn>
                    </v-row>
                    <v-row class="center">
                        <v-col cols="6" md="4">
                            <h2 :class="isMobile ? 'center' : ''">Create Group Deal</h2>
                        </v-col>
                    </v-row>
                    <v-container>
                        <v-row class="center">
                            <v-col>
                                <v-text-field
                                    outlined
                                    @blur="resetTextValidation"
                                    :rules="dealNameRules"
                                    color="#00006d"
                                    v-model="deal.dealName"
                                    class="ja-field"
                                    label="Deal Name"
                                ></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field
                                    outlined
                                    @blur="resetTextValidation"
                                    :rules="useLimitRules"
                                    color="#00006d"
                                    type="number"
                                    v-model.number="deal.useLimit"
                                    class="ja-field"
                                    label="Number Of Uses"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="center">
                            <v-col>
                                <v-textarea
                                    label="Description"
                                    outlined
                                    @blur="resetTextValidation"
                                    :rules="descriptionRules"
                                    v-model="deal.eventDescription"
                                ></v-textarea>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-select
                                    color="#00006d"
                                    outlined
                                    @change="resetTextValidation"
                                    :items="dealTypes"
                                    v-model.number="deal.dealType"
                                    class="ja-field"
                                    label="Deal Type"
                                ></v-select>
                            </v-col>
                            <v-col>
                                <v-text-field
                                    color="#00006d"
                                    outlined
                                    @blur="resetTextValidation"
                                    type="number"
                                    :rules="dealValueRules"
                                    v-model.number="deal.dealValue"
                                    class="ja-field"
                                    :label="valueLabel"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-container>
                            <image-card
                                v-if="dealPhoto"
                                @remove-business-photo="removePhoto"
                                @add-photo="addPhoto"
                                :multiFlag="false"
                                :index="0"
                                :photo="dealPhoto"
                            ></image-card>
                            <image-card
                                v-else
                                @remove-business-photo="removePhoto"
                                @add-photo="addPhoto"
                                :multiFlag="false"
                                :photo="addImagePlaceholder"
                            ></image-card>
                        </v-container>
                        <v-row class="center">
                            <h2>Group Size</h2>
                        </v-row>
                        <v-row class="center px-6">
                            <v-col cols="4" sm="3" md="2">
                                <v-card @click="deal.groupSize = 1" :color="deal.groupSize === 1 ? 'primary' : ''">
                                    <v-img :src="singleIcon"></v-img>
                                </v-card>
                            </v-col>
                            <v-col cols="4" sm="3" md="2">
                                <v-card @click="deal.groupSize = 2" :color="deal.groupSize === 2 ? 'primary' : ''">
                                    <v-img :src="twoIcon"></v-img>
                                </v-card>
                            </v-col>
                            <v-col cols="4" sm="3" md="2">
                                <v-card @click="deal.groupSize = 3" :color="deal.groupSize === 3 ? 'primary' : ''">
                                    <v-img :src="threeIcon"></v-img>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row class="center px-6">
                            <v-col cols="4" sm="3" md="2">
                                <v-card @click="deal.groupSize = 4" :color="deal.groupSize === 4 ? 'primary' : ''">
                                    <v-img :src="fourIcon"></v-img>
                                </v-card>
                            </v-col>
                            <v-col cols="4" sm="3" md="2">
                                <v-card @click="deal.groupSize = 5" :color="deal.groupSize === 5 ? 'primary' : ''">
                                    <v-img :src="fiveIcon"></v-img>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row class="center my-6">
                            <site-button
                                v-if="selectedDeal"
                                :colNum="5"
                                :marginNumber="1"
                                btnType="text"
                                text="Delete Deal"
                                iconType="SVG"
                                colorClasses="secondary-icon"
                                iconColor="primary-icon"
                                @click-event="deleteDeal"
                                :iconString="deleteDealIcon"
                            ></site-button>
                            <site-button
                                v-if="selectedDeal"
                                :colNum="5"
                                :marginNumber="1"
                                btnType="text"
                                text="Edit Deal"
                                iconType="SVG"
                                colorClasses="secondary-icon"
                                iconColor="primary-icon"
                                @click-event="updateGroupDeal"
                                :iconString="modifyDealIcon"
                            ></site-button>
                            <site-button
                                v-else
                                :colNum="10"
                                :marginNumber="2"
                                btnType="text"
                                text="Add Deal"
                                iconType="SVG"
                                colorClasses="secondary-icon"
                                iconColor="primary-icon"
                                @click-event="createGroupDeal"
                                :iconString="addDealIcon"
                            ></site-button>
                        </v-row>
                    </v-container>
                </v-form>
            </v-flex>
        </v-card>
    </v-dialog>
</template>

<style scoped>
::v-deep .v-dialog{
    overflow-y: hidden !important;
    border-radius: 15px;
    height: 95%;
    max-height: 95% !important;
    max-width: 80%;
}

.dialog-card{
    height: 100%; 
    overflow-y: hidden;
}

.inner-card-flex{
    height: 100%; 
    overflow-y: auto; 
    margin-left: 0; 
    margin-right: 0;
}
</style>

<script>
import SiteButton from '../SiteButton'
import DealTypes from '../../../assets/Enums/DealTypeEnum'
import ImageCard from '../ImageCard'
import { nanoid } from 'nanoid'

export default {
    components: {
        'site-button': SiteButton,
        'image-card': ImageCard,
    },
    props: {
        showDialog: {
            type: Boolean,
            default: false,
        },
        selectedDeal: {
            type: Object,
            default: null,
        },
    },
    data: () => ({
        deal: {
            id: '',
            dealName: '',
            useLimit: 0,
            eventDescription: '',
            dealType: DealTypes.AMOUNT,
            groupSize: 1,
            dealValue: null,
            dealPhoto: null,
        },
        validationTimeout: null,
    }),
    watch: {
        selectedDeal(newDeal) {
            console.log('new deal')
            if (newDeal) {
                this.deal = newDeal
            } else {
                this.resetDeal()
            }
            this.$refs.groupDealForm.resetValidation()
        },
    },
    methods: {
        addPhoto(files) {
            const item = files[0]
            const reader = new FileReader()
            console.log('add photo: ' + item.name)
            reader.onload = event => {
                this.deal.dealPhoto = {
                    photoData: event.target.result,
                    photoFile: item,
                }
            }
            reader.readAsDataURL(item)
        },
        resetTextValidation() {
            if (this.validationTimeout) {
                window.clearTimeout(this.validationTimeout)
                this.validationTimeout = null
            }

            this.validationTimeout = setTimeout(() => {
                this.$refs.groupDealForm.resetValidation()
            }, 3000)
        },
        removePhoto() {
            this.deal.dealPhoto = null
        },
        createGroupDeal() {
            console.log('create-deal')
            if (this.$refs.groupDealForm.validate()) {
                this.deal.id = nanoid(5)
                this.$emit('add-deal', Object.assign({}, this.deal))
                this.resetDeal()
                this.resetTextValidation()
                this.dialogControl = false
            } else {
                this.resetTextValidation()
            }
        },
        updateGroupDeal() {
            console.log('update-deal')
            if (this.$refs.groupDealForm.validate()) {
                this.$emit('update-deal', Object.assign({}, this.deal))
                this.resetDeal()
                this.resetTextValidation()
                this.dialogControl = false
            } else {
                this.resetTextValidation()
            }
        },
        deleteDeal() {
            this.$emit('delete-deal', Object.assign({}, this.deal))
            this.dialogControl = false
        },
        resetDeal() {
            this.deal.id = ''
            this.deal.dealName = ''
            this.deal.useLimit = 0
            this.deal.eventDescription = ''
            this.deal.dealType = DealTypes.AMOUNT
            this.deal.dealPhoto = null
            this.deal.groupSize = 1
            this.deal.dealValue = null
        },
    },
    computed: {
        dialogControl: {
            get() {
                return this.showDialog
            },
            set(newVal) {
                console.log('newVal: ' + newVal)
                this.$emit('set-dialog-control', newVal)
                this.resetDeal()
            },
        },
        valueLabel() {
            return this.deal.dealType === DealTypes.BUYONEGET ? 'Buy One Get ?' : this.deal.dealType + ' Off'
        },
        dealTypes() {
            return [DealTypes.AMOUNT, DealTypes.PERCENTAGE, DealTypes.BUYONEGET]
        },
        isMobile() {
            return this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm'
        },
        modifyDealIcon() {
            return require('../../../assets/Modify-Deal.svg')
        },
        deleteDealIcon() {
            return require('../../../assets/Delete-Group-Deal.svg')
        },
        addDealIcon() {
            return require('../../../assets/Add-Deal.svg')
        },
        singleIcon() {
            return require('../../../assets/Group-One.svg')
        },
        twoIcon() {
            return require('../../../assets/Group-Two.svg')
        },
        threeIcon() {
            return require('../../../assets/Group-Three.svg')
        },
        fourIcon() {
            return require('../../../assets/Group-Four.svg')
        },
        fiveIcon() {
            return require('../../../assets/Group-Five.svg')
        },
        addImagePlaceholder() {
            return require('../../../assets/Add-Image-Placeholder.svg')
        },
        dealPhoto() {
            return this.deal.dealPhoto ? this.deal.dealPhoto.photoData ? this.deal.dealPhoto.photoData : this.deal.dealPhoto : null;
        },
        dealNameRules() {
            return [v => !!v || 'Deal Name is required']
        },
        useLimitRules() {
            return [v => v > 1 || 'Use Limit must be greater than 1']
        },
        descriptionRules() {
            return [v => !!v || 'Please include a Description']
        },
        dealValueRules() {
            return this.deal.dealType === DealTypes.AMOUNT
                ? this.dealValueAmountRules
                : this.deal.dealType === DealTypes.PERCENTAGE
                ? this.dealValuePercentageRules
                : this.dealBuyGetRules
        },
        dealValuePercentageRules() {
            return [
                v => !!v || 'Please include a percentage',
                v => (v > 0 && v < 100) || 'Please enter a valid percentage',
            ]
        },
        dealValueAmountRules() {
            return [v => !!v || 'Please include an amount', v => v > 0 || 'Please enter an amount greater than 0']
        },
        dealBuyGetRules() {
            return [
                v => !!v || 'Please include the number of free items',
                v => v > 0 || 'Please enter an item number greater than 0',
            ]
        },
    },
}
</script>
